import AdherenceErrorRepair from './adherence-error-repair';

export default AdherenceErrorRepair;
